import { render, staticRenderFns } from "./UnifiedPayButton.vue?vue&type=template&id=36cbfc54&scoped=true"
import script from "./UnifiedPayButton.vue?vue&type=script&lang=js"
export * from "./UnifiedPayButton.vue?vue&type=script&lang=js"
import style0 from "./UnifiedPayButton.vue?vue&type=style&index=0&id=36cbfc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbfc54",
  null
  
)

export default component.exports